import { McpToolInput } from './mcp-tool-input'
import { McpToolOutput } from './mcp-tool-output'

export enum McpToolName {
  CreateContact = 'create_contact',
  GetContact = 'get_contact',
  UpdateContact = 'update_contact',
  GetContacts = 'get_contacts',
  RemoveContact = 'remove_contact',
  AssignContactTag = 'assign_contact_tag',
  RemoveContactTag = 'remove_contact_tag',
  GetContactFields = 'get_contact_fields',
  CreateTag = 'create_tag',
  GetTag = 'get_tag',
  GetTags = 'get_tags',
  UpdateTag = 'update_tag',
  RemoveTag = 'remove_tag',
  CreateNewsletter = 'create_newsletter',
  GetNewsletter = 'get_newsletter',
  GetNewsletters = 'get_newsletters',
  UpdateNewsletter = 'update_newsletter',
  CreateFunnel = 'create_funnel',
  GetFunnel = 'get_funnel',
  GetFunnels = 'get_funnels',
  CreateFunnelStep = 'create_funnel_step',
  GetFunnelStep = 'get_funnel_step',
  GetFunnelSteps = 'get_funnel_steps',
  SaveContent = 'save_content',
}

export type McpTools = Record<
  McpToolName,
  {
    input: McpToolInput
    output: McpToolOutput
  }
>
